export default {
  home: {
    title: 'HTML5ゲームコレクション',
    subtitle: 'ブラウザですぐにプレイ。ダウンロード不要、楽しさだけ！',
    browseGames: 'ゲームを閲覧',
    popularGames: '人気ゲーム',
    newGames: '新作ゲーム',
    recommendedGames: 'おすすめゲーム',
    recentlyPlayed: '最近プレイしたゲーム',
    popular: '人気',
    genres: {
      casual: 'カジュアル',
      puzzle: 'パズル',
      racing: 'レース',
      racing_driving: 'レース＆ドライビング',
      shooter: 'シューティング',
      simulation: 'シミュレーション',
      strategy: '戦略',
      sports: 'スポーツ',
      agility: '敏捷性',
      battle: 'バトル',
      care: 'ケア',
      cooking: '料理',
      football: 'サッカー',
      '.IO': 'リアルタイム対戦',
      merge: 'マージ',
      all: 'すべて',
      other: 'その他',
      dressup: 'ドレスアップ',
      adventure: 'アドベンチャー',
      mahjong_connect: '麻雀＆コネクト',
      jigsaw: 'ジグソー',
      basketball: 'バスケットボール',
      quiz: 'クイズ',
      bubble_shooter: 'バブルシューター',
      match3: 'マッチ3',
      boardgames: 'ボードゲーム',
      educational: '教育',
      cards: 'カード'
    }
  },
  games: {
    playNow: '今すぐプレイ',
    relatedGames: '関連ゲーム',
    instructions: 'ゲーム説明',
    controlsTitle: 'ゲームコントロール',
    addToFavorites: 'お気に入りに追加',
    removeFromFavorites: 'お気に入りから削除',
    share: 'ゲームをシェア',
    reportIssue: '問題を報告',
    fullscreen: '全画面モード',
    exitFullscreen: '全画面を終了'
  },
  categories: {
    title: 'ゲームカテゴリー',
    subtitle: '豊富なゲームカテゴリーを探索しよう',
    allCategories: 'すべてのカテゴリー',
    gamesInCategory: '{count}個のゲーム',
    categoryDescription: 'ここでは{category}カテゴリーのすべてのゲームを見つけることができます。様々なスタイルから選んで、すぐにプレイを始めましょう！',
    pageTitle: 'ゲームカテゴリー',
    pageDescription: '多様なゲームカテゴリーを探索して、お気に入りのゲームタイプを見つけよう',
    allGames: 'すべてのゲーム',
    gamesFound: '{count}個のゲームが見つかりました',
    other: 'その他',
    taggedGames: '{tag}ゲーム',
    noGamesInCategory: 'このカテゴリーにはゲームがありません',
    loadMore: 'もっと読み込む',
    otherGames: 'その他のゲーム',
    seoTitle: 'GoGameVault - ゲームカテゴリー | 無料オンラインHTML5ゲーム',
    seoDescription: 'GoGameVaultの多様なゲームカテゴリーを探索し、アクション、パズル、アーケード、スポーツ、レースなど、お気に入りのゲームタイプを見つけましょう。',
    seoKeywords: 'ゲームカテゴリー,オンラインゲーム,無料ゲーム,HTML5ゲーム,ブラウザゲーム',
    descriptions: {
      'Casual': '全年齢向けの簡単で気軽に楽しめるカジュアルゲーム、プレッシャーなくゲームを楽しめます。',
      'Puzzle': 'パズルや頭の体操で満足感が得られる脳トレパズルゲーム。',
      'Racing & Driving': 'スリリングなレースやドライブゲームで、スピードと興奮を体験しましょう。',
      'Shooter': '照準の精度と反応速度が試されるシューティングゲーム、敵を倒して勝利を目指します。',
      'Simulation': '都市経営から飛行機操縦まで、現実世界のさまざまな体験をシミュレートします。',
      'Strategy': '慎重な計画と戦術的思考が必要なストラテジーゲーム、最適な戦略で勝利を目指します。',
      'Sports': 'さまざまなスポーツをシミュレートするスポーツゲーム、あなたの運動能力を披露しましょう。',
      'Agility': '反応速度と調整力が試されるアジリティゲーム、様々な挑戦に素早く対応します。',
      'Battle': '対戦相手と激しく競い合うバトルゲーム、スキルと戦略で勝利を掴みましょう。',
      'Care': 'ペットや患者、その他のキャラクターの世話を楽しむケアゲーム。',
      'Cooking': '料理の腕前を披露し、美味しい料理を作ってレストランを経営するクッキングゲーム。',
      'Football': '世界で最も人気のあるスポーツを体験し、サッカーの技術と戦術を披露しましょう。',
      '.IO': 'リアルタイム対戦ゲーム、世界中のプレイヤーと競い合い成長するマルチプレイヤーオンライン対戦ゲーム。',
      'Merge': '同じアイテムを組み合わせて新しいアイテムを作る、シンプルで面白いマージゲーム。',
      'other': '通常のカテゴリーに属さないユニークなゲーム体験。',
      'generic': 'さまざまな{tag}ゲームを探索して、お気に入りを見つけましょう。'
    }
  },
  search: {
    title: '検索結果',
    placeholder: 'ゲームを検索...',
    resultsFor: '「{query}」の検索結果',
    noResults: 'ゲームが見つかりませんでした',
    noResultsMessage: '「{query}」に関連するゲームが見つかりませんでした',
    tryAgain: '別のキーワードを試すか、カテゴリーを閲覧してください。',
    returnToHomepage: 'ホームページに戻る',
    foundResults: '{count}個のゲームが見つかりました',
    seoTitle: '「{query}」を検索 - GoGameVault | 無料オンラインHTML5ゲーム',
    seoDescription: 'GoGameVaultで「{query}」に関連する無料オンラインHTML5ゲームを検索。様々な楽しいゲームをダウンロード不要で、ブラウザで直接プレイできます。'
  },
  gameDetail: {
    title: 'ゲーム詳細',
    gameTitle: 'ゲームタイトル',
    genres: 'ゲームジャンル',
    tags: 'タグ',
    gameDescription: 'ゲーム説明',
    controlsAndInstructions: 'コントロールと説明',
    similarGames: '類似ゲーム',
    new: '新着ゲーム',
    playAmazingGame: 'この素晴らしいゲームを今すぐプレイ',
    noSimilarGames: '類似ゲームはありません',
    gameNotFound: 'ゲームが見つかりません',
    gameNotExistOrRemoved: 'このゲームは存在しないか削除されました',
    backToHome: 'ホームページに戻る',
    seoTitle: '{title} - 無料でオンラインプレイ | GoGameVault',
    seoTitleNotFound: 'ゲームが見つかりません | GoGameVault',
    seoKeywords: '{title}, オンラインゲーム, 無料ゲーム, {tags}, HTML5ゲーム',
    gameUnavailable: 'ゲームは一時的に利用できません',
    tryAgainLater: '後でもう一度お試しください',
    share: 'シェア',
    openInNewTab: '新しいタブで開く'
  },
  about: {
    title: '私たちについて',
    aboutUs: '私たちについて',
    ourMission: '私たちのミッション',
    contactUs: 'お問い合わせ',
    privacyPolicy: 'プライバシーポリシー',
    termsOfService: 'サービス利用規約',
    feedbackTitle: 'フィードバック',
    feedbackText: '私たちは常にウェブサイトの改善に取り組んでいます。提案や問題がありましたら、お知らせください！',
    missionTitle: '私たちのミッション',
    missionText1: 'GoGameVaultは、ユーザーに最高の無料オンラインゲーム体験を提供することに専念しています。ダウンロードなしで楽しめる、楽しく高品質なHTML5ゲームを厳選しています。',
    missionText2: '私たちの目標は、プレイヤーが好きなゲームを簡単に見つけてプレイできる、ユーザーフレンドリーなゲームプラットフォームを作ることです。',
    feature1Title: '厳選されたゲーム',
    feature1Text: '高品質のグラフィックとスムーズなゲームプレイを確保するため、各ゲームを慎重に選んでいます。',
    feature2Title: 'いつでもどこでもプレイ',
    feature2Text: 'すべてのゲームは追加ソフトウェアのダウンロードやインストールなしで、ブラウザで直接実行できます。',
    feature3Title: '完全無料',
    feature3Text: '私たちのすべてのゲームは、隠れた料金やアプリ内購入なしで完全に無料です。',
    contactTitle: 'お問い合わせ',
    contactText: '質問、提案、フィードバックがありましたら、お気軽にお問い合わせください。私たちはユーザーの意見を重視し、サービスの継続的な改善に取り組んでいます。',
    seoTitle: 'GoGameVault - 私たちについて | 無料オンラインHTML5ゲーム',
    seoDescription: 'GoGameVaultは、ダウンロードなしでどこでもプレイできる厳選されたゲームを提供する無料オンラインHTML5ゲームプラットフォームです。私たちのミッションと特徴について学びましょう。',
    seoKeywords: 'オンラインゲーム,無料ゲーム,HTML5ゲーム,ブラウザゲーム,ダウンロード不要'
  },
  notFound: {
    title: 'ページが見つかりません',
    message: '申し訳ありませんが、アクセスしたページは存在しないか削除されました。元の軌道に戻りましょう！',
    returnHome: 'ホームページに戻る',
    goBack: '戻る',
    popularGames: '人気ゲームのおすすめ',
    popularGamesDesc: 'これらの特集ゲームを探索して、あなたのゲームの旅を始めましょう',
    seoTitle: 'ページが見つかりません - GoGameVault',
    seoDescription: '申し訳ありませんが、アクセスしたページはGoGameVaultに存在しません。新しいゲーム体験のために人気ゲームをブラウズしてください。'
  },
  categoryGames: {
    games: 'ゲーム',
    gamesAvailable: '{count}個のゲームが利用可能',
    noGamesFound: 'ゲームが見つかりません',
    noGamesInCategory: 'このカテゴリーにはゲームがありません',
    exploreCategories: '他のカテゴリーを探索',
    backToCategories: 'カテゴリーに戻る',
    invalidCategory: '無効なカテゴリー',
    categoryNotExist: '探しているカテゴリーは存在しません。',
    browseCategories: 'すべてのカテゴリーを閲覧',
    category: 'カテゴリー',
    seoTitle: '{tag}ゲーム - オンラインでプレイ - GoGameVault',
    seoDescriptionWithGames: '{count}個の特集{tag}ゲームを無料でブラウズしてプレイ。すべてのゲームはダウンロード不要でブラウザで直接プレイできます。',
    seoDescriptionDefault: '私たちの{tag}ゲームを無料でブラウズしてプレイ。すべてのゲームはダウンロード不要でブラウザで直接プレイできます。',
    seoKeywords: '{tag}ゲーム,無料オンラインゲーム,ブラウザゲーム'
  }
}; 